import { gql } from "@apollo/client";

export const ERP_VERSION = gql`
  mutation erpVersion {
    erpVersion {
      correlationId
    }
  }
`;

export const RESET_CACHE = gql`
  mutation resetCache($input: ResetInputType!) {
    resetCache(input: $input) {
      correlationId
    }
  }
`;

export const PUBLISH_LANGUAGE = gql`
  mutation publishLanguage {
    publishLanguage {
      correlationId
    }
  }
`;

export const REQUEST_DEIMOS_VERSION = gql`
  mutation requestDeimosVersion {
    requestDeimosVersion
  }
`;
